var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('h3',[_vm._v(" "+_vm._s(_vm.$t("browser_close.txt1"))+" ")]),_c('img',{attrs:{"src":require("../../assets/img/ALLOSURVIE_App_EcranAccueilMobile.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }